import { camelCaseToDisplayString } from "../utils/string.utils";

export enum BaseLocation {
  aspen = "aspen",
  beaverCreek = "beaverCreek",
  breckenridge = "breckenridge",
  deerValley = "deerValley",
  keystone = "keystone",
  parkCity = "parkCity",
  steamboatSprings = "steamboatSprings",
  vail = "vail",
  whistler = "whistler",
}

export function baseLocationToString(baseLocation: BaseLocation | undefined): string {
  return camelCaseToDisplayString(baseLocation);
}
